"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidatorPropTypes = exports.ValidationPropType = void 0;
require("core-js/modules/es.regexp.constructor.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.to-string.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ValidatorPropTypes = exports.ValidatorPropTypes = [_propTypes.default.string, _propTypes.default.bool, _propTypes.default.func, _propTypes.default.instanceOf(RegExp), _propTypes.default.shape({
  value: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number, _propTypes.default.instanceOf(RegExp)]),
  message: _propTypes.default.string
})];
const ValidationPropType = exports.ValidationPropType = {
  required: _propTypes.default.oneOfType(ValidatorPropTypes),
  pattern: _propTypes.default.oneOfType(ValidatorPropTypes),
  maxLength: _propTypes.default.oneOfType(ValidatorPropTypes),
  minLength: _propTypes.default.oneOfType(ValidatorPropTypes),
  max: _propTypes.default.oneOfType(ValidatorPropTypes),
  min: _propTypes.default.oneOfType(ValidatorPropTypes)
};